import { AVATAR_GOLD, displayInitials, hasAvatarSrc } from "../utils/userAvatarUtils";

/**
 * Stable avatar — empty/missing src shows initials on gold (#C4790A), never random placeholders.
 */
export default function UserAvatar({
  src,
  alt = "",
  name = "",
  className = "",
  imgClassName = "",
  initialsClassName = "",
  style,
}) {
  const resolved = hasAvatarSrc(src);

  if (!resolved) {
    const initials = displayInitials(alt || name);
    return (
      <span
        className={`user-avatar-initials ${className} ${initialsClassName}`.trim()}
        style={{
          background: AVATAR_GOLD,
          color: "#fff",
          ...style,
        }}
        aria-hidden={alt ? undefined : true}
        title={alt || name || undefined}
      >
        {initials}
      </span>
    );
  }

  return (
    <img
      src={src}
      alt={alt || name || ""}
      className={`user-avatar-img ${className} ${imgClassName}`.trim()}
      style={style}
      loading="lazy"
    />
  );
}
